// extracted by mini-css-extract-plugin
export default {"policiesContainer":"xOMjP","minimalContainer":"mOo2q"};